enum ActionTypes {
	request = 'ProductPriceHistory.request',
	receive = 'ProductPriceHistory.receive',
	pruneAll = 'ProductPriceHistory.pruneAll',
}

export default ActionTypes;
